import BaseM from './recordm.model.entity.js';

// Model representing an external entity.
//
// todo jone confirmar: This is used in the unified search and in the definition search.
var ExternalInstanceM = function(core, data) {
    /* eslint-disable-next-line prefer-rest-params */
    BaseM.apply(this, arguments);

    this.data = data || {};

    this._entityKey = ExternalInstanceM.entityKey;

    this.loaded_event_name = "recordm:loaded:instances/external:" + this.data.id;
    this.update_event_name = "recordm:saved:instances/external:" + this.data.id;
    this.delete_event_name = "recordm:deleted:instances/external:" + this.data.id;
};

ExternalInstanceM.entityKey = 'instances/external';
ExternalInstanceM.prototype = new BaseM();
ExternalInstanceM.prototype.constructor = ExternalInstanceM;

ExternalInstanceM.get = BaseM.buildGetFor(ExternalInstanceM);

ExternalInstanceM.prototype.getDescription = function() {
    return this.getInstanceLabel();
};

// Returns the instance main identifier.
// Its the first line in the unified result.
//
// Note: It only shows the first field with the key $instanceLabel
ExternalInstanceM.prototype.getInstanceLabel = function() {
    const labelField = this.data._meta_inf.instanceLabel ?? "id"; //use id field if there's no instanceLabel
    return BaseM.getReadableFieldValue(this.data, labelField);
};

// Returns an array with a field name and field value.
// it should appear under the main identifier in the auto-complete results
ExternalInstanceM.prototype.getInstanceDescription = function() {
    var _this = this;
    var descriptionFields = this.data._meta_inf.instanceDescription || [];

    return descriptionFields.map(function(descField) {
        return {
            label: descField,
            value: BaseM.getReadableFieldValue(_this.data, descField),
            //todo jone o que deveria ser isto?
            description: ""
        }
    });
};

export default ExternalInstanceM;
